/* eslint-disable react-hooks/exhaustive-deps */
import { Row, Select } from 'antd'
import { useTranslation } from 'next-i18next'
import React, { useState, useEffect } from 'react'
import { CustomCol, FormLabels } from 'src/components'
import { getCtCookie, updateCTCookie } from 'src/core/helpers'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import {
  setCurrency,
  changeUserCurrency,
  currencyListSelector,
  userAuthenticatedState,
} from 'src/features'

const UserPreferenceChangeCurrency: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const user = useAppSelector(userAuthenticatedState)
  const [selectedCurrency, setSelectedCurrency] = useState(user?.currency_token)
  const currencyList = useAppSelector(currencyListSelector)
  const { isMobile } = useWindowSize()
  const currencyCookie = getCtCookie('ct-currency')

  const handleCurrencyChange = (currency: number) => {
    setSelectedCurrency(currency)
    dispatch(changeUserCurrency({ currency }))
    const newCurrencyCode = currencyList.find(item => item?.id === currency)?.code
    dispatch(setCurrency(newCurrencyCode))
    updateCTCookie('ct-currency', newCurrencyCode)
  }

  useEffect(() => {
    const newCurrency = currencyList?.find(c => c.code === currencyCookie)?.id
    setSelectedCurrency(newCurrency)
  }, [currencyCookie])

  return (
    <Row className={isMobile && 'mt-5'}>
      <CustomCol>
        <FormLabels
          title={t('settings.Currency')}
          subtitle={t('settings.ChoseCurrency')}
        />
      </CustomCol>
      <CustomCol>
        {currencyList && <Select
          value={selectedCurrency}
          size='large'
          style={{ width: '100%' }}
          onChange={handleCurrencyChange}
        >
          {currencyList?.map(item => (
            <Select.Option value={item?.id} key={item?.id}>
              {item?.code} <strong>{item?.symbol}</strong>
            </Select.Option>
          ))}
        </Select>
        }
      </CustomCol>
    </Row>
  )
}

export default UserPreferenceChangeCurrency
